module.exports = __webpack_public_path__ + "resources/images/abn_amro-2069463648895e95a28ebd952781dc8b-cache.png";